export default {
  methods: {
    getBasedOnVolNetCbmRules (vol, shouldUpdateTransportType) {
      console.log('getBasedOnVolNetCbmRules', shouldUpdateTransportType)
      let transportType = this.getSystemOptionByCodeAndType('S', 'TRANSPORT_TYPE')
      let mode = this.getSystemOptionByCodeAndType('FCL', 'MODE')
      let containerTypeCode = null
      if (vol > 0 && vol < 1 && shouldUpdateTransportType) {
        transportType = this.getSystemOptionByCodeAndType('A', 'TRANSPORT_TYPE')
        mode = this.getSystemOptionByCodeAndType('AIR', 'MODE')
        containerTypeCode = null
      } else if (vol > 0 && vol < 15) {
        mode = this.getSystemOptionByCodeAndType('LCL', 'MODE')
      } else if (vol >= 15 && vol < 30.1) {
        containerTypeCode = '20FT_STANDARD'
      } else if (vol >= 30.1 && vol < 60.1) {
        containerTypeCode = '40FT_STANDARD'
      } else if (vol >= 60.1 && vol < 70.1) {
        containerTypeCode = '40FT_HIGH_CUBE'
      } else if (vol >= 70.1 && vol <= 90) {
        containerTypeCode = '20FT_40FT_STANDARD'
      }
      const containerType = containerTypeCode && this.getSystemOptionByCodeAndType(containerTypeCode, 'CONTAINER_TYPE')
      return {
        transportType: transportType || {},
        mode: mode || {},
        containerType: containerType || {}
      }
    },
    getSystemOptionByCodeAndType (code, optionTypeCode) {
      // implemented by parent - ignore me
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/quote-form-rules.js